<template>
  <div class="header">
    <div
      class="phone-header"
      v-if="screenWidth <=1200"
    >
      <van-nav-bar
        title="标题"
        class="home-index"
        :class="isFixed? 'is-fixed': ''"
      >
        <!-- v-if="!($route.path =='/indexPage' || $route.path =='/')" -->
        <template #left>
          <!-- <van-icon name="wap-home"  @click="handleClick('/indexPage')"/> -->
          <!--<span-->
            <!--class="text-left"-->
            <!--@click="showPopUpLeft"-->
          <!--&gt;{{title}}</span>-->
            <div class="left-image"  @click="showPopUpLeft">
                 <img :src="currentTitle" width="25" style="margin-top: 5px;">
            </div>
        </template>
        <template #title>
          <div class="nav-img">
            <!--<img src="../../assets/phone/page/logo1.png">-->
            <img src="../../assets/phone/page/logo2.png">
          </div>
        </template>
        <template
          #right
          v-if="$route.path=='/infoService'"
        >
          <van-icon
            name="bars"
            @click="showPopup"
          />
        </template>
      </van-nav-bar>
    </div>
    <div
      class="pc-header"
      v-else
    >
      <header class="page-header">
        <div
          class="register-box"
          v-show="false"
        >
          <!--showRegister&&showIndex==0-->
          <img
            src="../../assets/images/page1/fighting.png"
            alt
          />
          <span>守望相助，抗击疫情：电子病历评级辅助系统免费使用</span>
          <span
            class="pointer enterance"
            @click="yxgjLogin"
          >点击进入 ></span>
          <img
            class="close-img pointer"
            src="../../assets/images/page1/close.png"
            title="关闭"
            alt
            @click="showRegister=false"
          />
        </div>
        <div class="header-inner">
          <div class="company-logo">
            <!--<img src="../../assets/images/page1/logo1.png" alt @click="handleClick('/')"/>-->
            <!--<span class="split"></span>-->
            <img
              src="../../assets/phone/page/logo2.png"
              alt="医信管家"
              @click="handleClick('/indexPage')"
            />
          </div>
          <div class="nav-list">
            <router-link
              to="/indexPage"
              class="item"
            >首页</router-link>
            <router-link
              :to="{name: 'infoService',query:{id:1}}"
              class="item"
            >产品功能</router-link>
            <router-link
              to="/companyIntroduce"
              class="item"
            >公司简介</router-link>
            <router-link
              to="/successExample"
              class="item"
            >成功案例</router-link>
            <router-link
              to="/cooperation"
              class="item"
            >商务合作</router-link>
          </div>
          <div class="menu-box">
            <!-- <ul class="menu-list">
                <li v-for="(menuitem,index) in menuList" :key="'menu'+index" :class="menuitem.class">
                  <div v-if="menuitem.type=='text'">{{menuitem.content}}</div>
                  <div v-else>{{menuitem.content}}</div>
                </li>
              </ul> -->
            <div
              class="btn login pointer"
              @click="yxgjLogin"
            >登录</div>
            <div
              class="btn register pointer"
              @click="register"
            >注册申请</div>
          </div>
        </div>
      </header>
    </div>
    <van-popup
      v-model="show"
      position="left"
      :style="{ height: '100%' ,width:'140px',paddingTop:'120px'}"
    >
        <div class="phone-nav">
            <div class="list"
                 v-for="(item,index) in routeList"
                 :key="'title_'+index"
                 @click="jumpTo(index,item.route)"
                 :class="$route.path===item.route ? 'active': ''">
                <img :src="item.imgHover" v-if="$route.path===item.route">
                <img :src="item.imgNormal" v-else>
                <span class="title">
                    {{item.name}}
                </span>
            </div>
        </div>
      <!--<van-sidebar v-model="activeKey">-->
        <!--<van-sidebar-item-->
          <!--v-for="(item,index) in routeList"-->
          <!--:key="'title_'+index"-->
          <!--:title="item.name"-->
          <!--@click="jumpTo(index,item.route)"-->
        <!--/>-->
      <!--</van-sidebar>-->
    </van-popup>
  </div>
</template>

<script>
import $ from "jquery";
export default {
    name: "headerCommon",
    props: ["isFixed", "showRegister"],
    data() {
        return {
            screenWidth: 0,
            show: false,
            activeKey: 0,
            routeList: [
                {
                    id: 1,
                    name: "首页",
                    route: "/indexPage",
                    imgNormal: require("../../assets/phone/nav/icon_home.png"),
                    imgHover: require("../../assets/phone/nav/icon_hometop.png")
                },
                {
                    id: 2,
                    name: "产品功能",
                    route: "/infoService",
                    imgNormal: require("../../assets/phone/nav/chanpin.png"),
                    imgHover: require("../../assets/phone/nav/chanpintop.png")
                },
                {
                    id: 3,
                    name: "公司简介",
                    route: "/companyIntroduce",
                    imgNormal: require("../../assets/phone/nav/shape.png"),
                    imgHover: require("../../assets/phone/nav/shapetop.png")
                },
                {
                    id: 4,
                    name: "成功案例",
                    route: "/successExample",
                    imgNormal: require("../../assets/phone/nav/anli.png"),
                    imgHover: require("../../assets/phone/nav/anlitop.png")
                },
                {
                    id: 5,
                    name: "商务合作",
                    route: "/cooperation",
                    imgNormal: require("../../assets/phone/nav/swhz.png"),
                    imgHover: require("../../assets/phone/nav/swhztop.png")
                }
            ],
            currentTitle: ""
        };
    },
    methods: {
        register() {
            this.$router.push({ path: "/registerPage" });
        },
        yxgjLogin() {
            window.location.href = this.$store.state.loginUrl;
            // window.location.href = "http://119.27.160.213:8087/web/login";
        },
        handleClick(path) {
            this.$router.push({
                path: path,
                query: {}
            });
        },
        showPopup() {
            /*展示右边弹框层*/
            this.$emit("popupHandle");
        },
        getTitle(path) {
            this.routeList.forEach(el => {
                if (el.route === path) {
                    this.currentTitle = el.imgHover;
                    this.activeKey = el.id - 1;
                }
            });
        },
        jumpTo(index, route) {
            // 手机端路由跳转
            // console.log(index, route);
            this.getTitle(route);
            if (route === '/infoService') {
                this.$router.push({
                    path: route,
                    query: {
                        id: 1
                    }
                });
            } else {
                this.$router.push({
                    path: route
                });
            }
            this.show = false;
        },
        showPopUpLeft() {
            this.show = !this.show;
        }
    },
    created() {
        this.getTitle(this.$route.path);
    },
    mounted() {
        let that = this;
        this.$nextTick(() => {
            that.screenWidth = document.documentElement.clientWidth;
        });
        $(window).bind("resize", function() {
            that.screenWidth = document.documentElement.clientWidth;
        });
    }
};
</script>

<style lang="less" scoped>
.header {
  .text-left {
    color: #00a0e9;
    font-size:1.041667rem;
  }
  .phone-header .home-index {
    z-index: 10000;
  }
.phone-nav{
    width: 100%;
    .list{
        width: 100%;
        overflow: hidden;
        height: 45px;
        /*line-height: 45px;*/
        display: flex;
        align-items: center;
        img{
            width: 1.2rem;
            float: left;
            margin: 0 10px 0 16px;
            align-items: center;
        }
        .title{
            float: left;
            font-size:1rem;
            align-items: center;
        }
        &.active{
            .title{
                color: #00a0e9;
            }
        }
    }
}
  /*.van-sidebar-item {*/
    /*height: 50px;*/
    /*text-align: left;*/
    /*line-height: 50px;*/
    /*color: #797f83;*/
    /*padding: 0!important;*/
  /*}*/
  /*.van-sidebar-item--select::before {*/
    /*width: 6px;*/
    /*height: 20px;*/
    /*border-radius: 4px;*/
    /*background-color: #0e7bdd;*/
  /*}*/
  /*.van-sidebar-item--select {*/
    /*color: #0e7bdd !important;*/
    /*font-weight: bold;*/
  /*}*/
  /*/deep/.van-sidebar-item .van-sidebar-item__text {*/
    /*font-size: .9rem;*/
    /*padding-left: 20px;*/
  /*}*/
  /*.van-sidebar {*/
    /*width: 100% !important;*/
    /*height: 100% !important;*/
  /*}*/
}
</style>




// WEBPACK FOOTER //
// src/components/common/headerCommon.vue